module.exports = __webpack_public_path__ + "img/log-in-01.dab2af34.svg";